import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Breadcrumb, Row, Card, Button, Skeleton } from 'antd';
import _ from 'lodash';

import OneRowData from 'components/OneRowData';

import { elipsis } from 'shared/utils/StringUtil';
import { permissionService } from 'shared/services';
import { userPermissions } from 'shared/constant';

import baseRoute from 'route';
import organizationRoute from '../../route';

import CompanyModules from '../CompanyRegister/CompanyModules';
import CompanyModulesView from '../CompanyRegister/CompanyModulesView';
import EmployeeRolesView from '../CompanyRegister/EmployeeRolesView';

import text from './CompanyDetail.page.translation';

import './CompanyDetail.style.less';

export class CompanyDetail extends Component {
  componentDidMount() {
    let employeeId = '';
    if (this.props.employeeId) {
      employeeId = this.props.employeeId;
    } else {
      const tempUrl = this.props.location.pathname.split('/');
      employeeId = tempUrl[tempUrl.length - 1];
    }

    if (employeeId) {
      this.props.getSingleCompany(employeeId, this.getSingleCompanyCallback);
    }
  }

  getSingleCompanyCallback = data => {
    if (data.payload.pic_id) {
      this.props.getSingleEmployee(data.payload.pic_id, null);
    }
  };

  renderRowData(data, key) {
    return <OneRowData key={key} data={data[key]} />;
  }

  _combineRolesToString = employeeData => {
    let result = '-';

    if (_.get(employeeData, 'modules', []).length > 0) {
      employeeData.modules.forEach((module, index) => {
        const name = _.get(module, 'name');
        if (index > 0) {
          result += `, ${name}`;
        } else {
          result = name;
        }
      });
    }

    return result;
  };

  _combinePermissionToString = employeeData => {
    let result = '-';

    if (_.get(employeeData, 'modules', []).length > 0) {
      employeeData.modules.forEach((module, index) => {
        const newPermission = module.view_all ? 'View all' : 'Company View';
        if (index > 0) {
          result += `, ${newPermission}`;
        } else {
          result = newPermission;
        }
      });
    }

    return result;
  };

  _renderContentLeft = () => {
    const {
      companyDetail,
      intl: { formatMessage },
    } = this.props;
    let listLeftSection = '';

    const employeeData = companyDetail.payload;
    const companyId = _.get(employeeData, 'organization_id', '');
    const npwpNumber = _.get(employeeData, 'npwp_number', '');
    const legalEntity = _.get(employeeData, 'legal_entity', '');
    const companyName = _.get(employeeData, 'name', '');
    const companyAddress = _.get(employeeData, 'address', '');
    const companyOwner = _.get(employeeData, 'owner_fullname', '');
    const companyEmail = _.get(employeeData, 'owner_email', '');
    // const companyRoles = this._combineRolesToString(employeeData);
    // const companyPermissions = this._combinePermissionToString(employeeData);

    const listLeftData = [
      {
        label: formatMessage(text.labelName),
        value: companyName,
      },
      {
        label: formatMessage(text.labelCompanyId),
        value: companyId,
      },
      {
        label: formatMessage(text.labelNpwpNumber),
        value: npwpNumber,
      },
      {
        label: formatMessage(text.labelLegalEntity),
        value: legalEntity,
      },
      {
        label: formatMessage(text.labelOwner),
        value: companyOwner,
      },
      {
        label: formatMessage(text.labelEmail),
        value: companyEmail,
      },
      {
        label: formatMessage(text.labelAddress),
        value: companyAddress,
        elipsis: elipsis(companyAddress, 30),
      },
      // {
      //   label: formatMessage(text.labelCompanyModule),
      //   value: companyRoles,
      //   elipsis: elipsis(companyRoles, 30),
      // },
      // {
      //   label: formatMessage(text.labelCompanyPermission),
      //   value: companyPermissions,
      //   elipsis: elipsis(companyPermissions, 30),
      // },
    ];
    listLeftSection = Object.keys(listLeftData).map(
      this.renderRowData.bind(this, listLeftData),
    );

    return (
      <Card.Grid className="card-grid-style minH210">
        <Skeleton
          loading={this.props.getLoading}
          active
          paragraph={{ rows: 4, width: ['100%', '100%', '100%', '100%'] }}
          title={false}
        >
          {listLeftSection}
        </Skeleton>
      </Card.Grid>
    );
  };

  _getContentRightValue = (companyDetail, employeeDetail) => {
    const result = {
      companyEmail: '-',
      companyPICName: '-',
      companyPICPhoneNumber: '-',
      companyPICPhoto: 'https://via.placeholder.com/100x100',
    };

    if (_.get(companyDetail, 'payload')) {
      const companyData = companyDetail.payload;
      result.companyEmail = _.get(companyData, 'owner_email', '');
    }

    if (_.get(employeeDetail, 'payload')) {
      const employeeData = employeeDetail.payload;
      const firstname = _.get(employeeData, 'firstname', '');
      const lastname = _.get(employeeData, 'lastname', '');

      result.companyPICName = `${firstname} ${lastname}`;

      if (employeeData.user_details) {
        result.companyPICPhoneNumber = employeeData.user_details.phone_mobile;
        result.companyPICPhoto = employeeData.user_details.profile_picture_url;
      }
    }

    return result;
  };

  _renderContentRight = () => {
    const {
      companyDetail,
      employeeDetail,
      intl: { formatMessage },
    } = this.props;
    let listRightSection = '';

    const value = this._getContentRightValue(companyDetail, employeeDetail);

    const listRightData = [
      {
        label: formatMessage(text.labelPicName),
        value: value.companyPICName,
      },
      {
        label: formatMessage(text.labelPicPhone),
        value: value.companyPICPhoneNumber,
      },
      {
        label: formatMessage(text.labelPicPhoto),
        url: value.companyPICPhoto,
      },
    ];
    listRightSection = Object.keys(listRightData).map(
      this.renderRowData.bind(this, listRightData),
    );

    return (
      <Card.Grid className="card-grid-style minH210">
        <Skeleton
          loading={this.props.getLoading}
          active
          paragraph={{ rows: 4, width: ['100%', '100%', '100%', '100%'] }}
          title={false}
        >
          {listRightSection}
        </Skeleton>
      </Card.Grid>
    );
  };

  _goToEditPage = companyId => {
    this.props.history.push(
      organizationRoute.COMPANY_EDIT.replace(':id', companyId),
    );
  };

  _renderEditbtn = () => {
    const {
      getLoading,
      companyDetail,
      intl: { formatMessage },
    } = this.props;

    const { checkPermission } = permissionService;
    const canEditCompany = checkPermission(
      userPermissions.UPDATE_COMPANY,
      true,
    );

    if (!getLoading && companyDetail.payload && canEditCompany) {
      const companyId = companyDetail.payload.organization_id;

      return (
        <Button
          type="primary"
          block
          className="btn edit-btn"
          onClick={() => this._goToEditPage(companyId)}
        >
          {formatMessage(text.btnEdit)}
        </Button>
      );
    }

    return null;
  };

  _getPageTitle = () => {
    const {
      intl: { formatMessage },
      disableBreadCrumb,
    } = this.props;

    let title = '';
    if (!disableBreadCrumb) {
      title = formatMessage(text.title);
    }

    return title;
  };

  render() {
    const {
      intl: { formatMessage },
      disableBreadCrumb,
      employeeDetail,
    } = this.props;

    const cardTitle = this._getPageTitle();

    const employeeRoles = _.get(
      employeeDetail,
      'payload.user_details.user_role',
      [],
    );
    const displayEmployeeRoles = employeeRoles.map(x => ({
      ...x,
      disabled: true,
      checked: true,
      hidden: false,
    }));

    const modules = _.get(
      employeeDetail,
      'payload.organization_details.modules',
      [],
    );
    const diplayModules = modules.map(x => ({
      ...x,
      viewAllDisabled: true,
      checked: true,
    }));

    return (
      <div className="main-content company-detail">
        {disableBreadCrumb ? null : (
          <div className="breadcrumb-wrapper">
            <Breadcrumb>
              <Breadcrumb.Item>
                <Link to={baseRoute.HOME}>Home</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link
                  to={organizationRoute.COMPANY_LIST.replace(
                    ':tab',
                    'view-company',
                  )}
                >
                  {formatMessage(text.breadcrumbList)}
                </Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {formatMessage(text.breadcrumbDetail)}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        )}

        <div className="white-box-wrapper company-detail-white-box">
          <Card title={cardTitle} bordered={false}>
            <Row type="flex">
              {this._renderContentLeft()}
              {this._renderContentRight()}
            </Row>
          </Card>
          <div className="company-roles-container">
            <CompanyModulesView
              availableModules={diplayModules}
              placeholder="Loading data..."
            />

            <div className="roles-title">Available Employee Roles</div>
            <CompanyModules
              availableModules={displayEmployeeRoles}
              colSpan={6}
              placeholder="Loading data..."
            />

            <div className="employee-roles-view">
              <EmployeeRolesView
                employeeRoles={displayEmployeeRoles}
                placeholder="Loading data..."
              />
            </div>
          </div>
          {this._renderEditbtn()}
        </div>
      </div>
    );
  }
}

CompanyDetail.propTypes = {
  history: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  getSingleCompany: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  companyDetail: PropTypes.object,
  getLoading: PropTypes.bool,
  employeeId: PropTypes.string,
  employeeDetail: PropTypes.object,
  disableBreadCrumb: PropTypes.bool,
  getSingleEmployee: PropTypes.func,
};

export default CompanyDetail;
